"use client";

import React, { useState } from "react";
import { Sidebar, SidebarBody, SidebarLink, Links } from "../ui/sidebar";
import { LayoutDashboard, LogOut, FileText, Building2, FolderKanban, Newspaper, HelpCircle, FileWarning, BadgeAlert, Flag, ShieldCheck } from "lucide-react";
import Link from "next/link";
import { motion } from "framer-motion";
import Image from "next/image";
import { signOut } from "next-auth/react";
import { cn } from "@/lib/utils";

export function SidebarComponent({ children }: { children: React.ReactNode }) {
  const links: Links[] = [
    {
      label: "Home",
      href: "/",
      icon: (
        <LayoutDashboard className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />
      ),
    },
    {
      label: "My Tickets",
      href: "/tickets",
      icon: (
        <FileText className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />
      ),
    },
    {
      label: "Help",
      href: "https://www.thedigitalproject.com.au/",
      icon: (
        <HelpCircle className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />
      ),
      target: "_blank",
    },

    {
      label: "Logout",
      href: "#",
      icon: (
        <LogOut className="text-neutral-700 dark:text-neutral-200 h-5 w-5 flex-shrink-0" />
      ),
      onClick: () => signOut({ callbackUrl: "/" }),
    },
  ];

  const [open, setOpen] = useState(false);

  return (
    <div
      className={cn(
        "flex flex-col md:flex-row",
        "bg-background",
        "w-full h-screen",
        "border border-border rounded-md",
        "overflow-hidden"
      )}
    >
      <Sidebar open={open} setOpen={setOpen}>
        <SidebarBody className="flex flex-col justify-between gap-10">
          <div className="flex flex-col flex-1">
            {open ? <Logo /> : <LogoIcon />}
            <div className="mt-8 flex flex-col gap-2">
              {links.map((link, idx) => (
                <SidebarLink key={idx} link={link} />
              ))}
            </div>
          </div>
          <div>
            <SidebarLink
              link={{
                label: "the Digital Project",
                href: "/",
                icon: (
                  <Image
                    src="/assets/tdp-square.png"
                    className="h-7 w-7 flex-shrink-0"
                    width={50}
                    height={50}
                    alt="Avatar"
                  />
                ),
              }}
            />
          </div>
        </SidebarBody>
      </Sidebar>
      <div className="flex-1">{children}</div>
    </div>
  );
}

export const Logo = () => {
  return (
    <Link
      href="#"
      className="font-normal flex space-x-2 items-center text-sm text-black py-1 relative z-20"
    >
      <Image
        src="/assets/tdp-square.png"
        width={24}
        height={20}
        alt="Logo"
        className="flex-shrink-0"
      />
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="font-medium text-black dark:text-white whitespace-pre"
      >
        Support Portal
      </motion.span>
    </Link>
  );
};

export const LogoIcon = () => {
  return (
    <Link
      href="#"
      className="font-normal flex space-x-2 items-center text-sm text-black py-1 relative z-20"
    >
      <Image
        src="/assets/tdp-square.png"
        width={24}
        height={20}
        alt="Logo"
        className="flex-shrink-0"
      />
    </Link>
  );
};